import * as React from "react";
import { KaartItem, IKaartItem } from "./KaartItem";

import "./Kaart.scss";
import {
  LoadingIndicatorImplementationInterface,
  withLoadingIndicator
} from "../Spinner/HOC/withLoadingIndicator";

export interface IKaartProps extends LoadingIndicatorImplementationInterface {
  titel: string;
  items: IKaartItem[] | null;
  isLoading: boolean;
  error: string | null;
  columns?: number;
}

export const Kaart = withLoadingIndicator((props: IKaartProps) => {
  const columnsClass = props.columns ? `columns-${props.columns}` : "";

  return (
    <div className="kaart">
      <h1>{props.titel}</h1>
      {props.items && (
        <ul className={`kaart-group ${columnsClass}`}>
          {props.items.map((item) => (
            <KaartItem item={item} key={item.label} />
          ))}
        </ul>
      )}
      {props.error && (
        <span className="alert alert-danger error-text" role="alert">
          {props.error}
        </span>
      )}
    </div>
  );
});
